var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import * as ReactDOM from "react-dom";
import { ReactElementFactory } from "../../element-factory";
import { SurveyElementBase } from "../../reactquestion_element";
import { attachKey2click } from "../../reactSurvey";
import { SvgIcon } from "../svg-icon/svg-icon";
import { SurveyActionBarSeparator } from "./action-bar-separator";
import { SurveyLocStringViewer } from "../../string-viewer";
var SurveyAction = /** @class */ (function (_super) {
    __extends(SurveyAction, _super);
    function SurveyAction(props) {
        var _this = _super.call(this, props) || this;
        _this.ref = React.createRef();
        return _this;
    }
    Object.defineProperty(SurveyAction.prototype, "item", {
        get: function () {
            return this.props.item;
        },
        enumerable: false,
        configurable: true
    });
    SurveyAction.prototype.getStateElement = function () {
        return this.item;
    };
    SurveyAction.prototype.renderElement = function () {
        //refactor
        var itemClass = this.item.getActionRootCss();
        var separator = this.item.needSeparator ? (React.createElement(SurveyActionBarSeparator, null)) : null;
        var itemComponent = ReactElementFactory.Instance.createElement(this.item.component || "sv-action-bar-item", {
            item: this.item,
        });
        return (React.createElement("div", { className: itemClass, id: "" + this.item.uniqueId, ref: this.ref },
            React.createElement("div", { className: "sv-action__content" },
                separator,
                itemComponent)));
    };
    SurveyAction.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.item.updateModeCallback = undefined;
    };
    SurveyAction.prototype.componentDidMount = function () {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        this.item.updateModeCallback = function (mode, callback) {
            queueMicrotask(function () {
                if (ReactDOM["flushSync"]) {
                    ReactDOM["flushSync"](function () {
                        _this.item.mode = mode;
                    });
                }
                else {
                    _this.item.mode = mode;
                }
                queueMicrotask(function () {
                    callback(mode, _this.ref.current);
                });
            });
        };
        this.item.afterRender();
    };
    return SurveyAction;
}(SurveyElementBase));
export { SurveyAction };
var SurveyActionBarItem = /** @class */ (function (_super) {
    __extends(SurveyActionBarItem, _super);
    function SurveyActionBarItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SurveyActionBarItem.prototype, "item", {
        get: function () {
            return this.props.item;
        },
        enumerable: false,
        configurable: true
    });
    SurveyActionBarItem.prototype.getStateElement = function () {
        return this.item;
    };
    SurveyActionBarItem.prototype.renderElement = function () {
        return React.createElement(React.Fragment, null, this.renderInnerButton());
    };
    SurveyActionBarItem.prototype.renderText = function () {
        if (!this.item.hasTitle)
            return null;
        return React.createElement(SurveyLocStringViewer, { locStr: this.item.locTitle, textClass: this.item.getActionBarItemTitleCss() });
    };
    SurveyActionBarItem.prototype.renderButtonContent = function () {
        var text = this.renderText();
        var svgIcon = !!this.item.iconName ? (React.createElement(SvgIcon, { className: this.item.cssClasses.itemIcon, size: this.item.iconSize, iconName: this.item.iconName, title: this.item.tooltip || this.item.title })) : null;
        return (React.createElement(React.Fragment, null,
            svgIcon,
            text));
    };
    SurveyActionBarItem.prototype.renderInnerButton = function () {
        var _this = this;
        var className = this.item.getActionBarItemCss();
        var title = this.item.tooltip || this.item.title;
        var buttonContent = this.renderButtonContent();
        var tabIndex = this.item.disableTabStop ? -1 : undefined;
        var button = attachKey2click(React.createElement("button", { className: className, type: "button", disabled: this.item.disabled, onMouseDown: function (args) { return _this.item.doMouseDown(args); }, onFocus: function (args) { return _this.item.doFocus(args); }, onClick: function (args) { return _this.item.doAction(args); }, title: title, tabIndex: tabIndex, "aria-checked": this.item.ariaChecked, "aria-expanded": this.item.ariaExpanded, "aria-labelledby": this.item.ariaLabelledBy, role: this.item.ariaRole }, buttonContent), this.item, { processEsc: false });
        return button;
    };
    return SurveyActionBarItem;
}(SurveyElementBase));
export { SurveyActionBarItem };
ReactElementFactory.Instance.registerElement("sv-action-bar-item", function (props) {
    return React.createElement(SurveyActionBarItem, props);
});
